// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"24919be1","395":"f005b296","795":"10f58263"}[chunkId] + ".chunk.js";
};